import { useTranslations } from "@zapier/i18n";
import { EmptyTableDisplay, useRouterParams } from "@zapier/shared";
import { EmptyConnectionsTable as EmptyConnectionsTableEnum } from "./useShowEmptyConnectionsTable";
import { useShowFirstConnectionEmptyState } from "./useShowFirstConnectionEmptyState";
import { FirstConnectionEmptyState } from "./FirstConnectionEmptyState";

interface Props {
  tableType: EmptyConnectionsTableEnum;
  onAddConnection: () => void;
  onAddManagedConnection: () => void;
}

export function EmptyConnectionsTable({
  tableType,
  onAddConnection,
  onAddManagedConnection,
}: Props) {
  const t = useTranslations("empty-connections-table");
  const showFirstConnectionEmptyState = useShowFirstConnectionEmptyState();

  const { clearFilterParams } = useRouterParams();

  /* Empty Search */
  if (tableType === EmptyConnectionsTableEnum.EmptySearchResults) {
    return (
      <EmptyTableDisplay
        actionButtonText={t("actions.clear-search")}
        headerText={t("messages.no-results-found")}
        icon="navSearch"
        onActionButton={() => clearFilterParams()}
        subHeaderText={t("messages.adjust-filters-help")}
      />
    );
  }

  /* Empty Shared List */
  if (tableType === EmptyConnectionsTableEnum.NoSharedConnections) {
    return (
      <EmptyTableDisplay
        icon="navConnectedAssets"
        headerText={t("messages.no-shared-connections")}
        subHeaderText={t("messages.shared-connections-help")}
      />
    );
  }

  /* True zero connections */
  if (showFirstConnectionEmptyState) {
    return (
      <FirstConnectionEmptyState
        onAddManagedConnection={onAddManagedConnection}
      />
    );
  }

  return (
    <EmptyTableDisplay
      icon="navConnectedAssets"
      headerText={t("messages.no-connections-added")}
      subHeaderText={t("messages.add-connection-help")}
      actionButtonText={t("actions.add-connection")}
      actionButtonIcon="formAdd"
      actionButtonColor="secondary"
      onActionButton={onAddConnection}
    />
  );
}
